window.addEventListener(
  'DOMContentLoaded',
  () => {
    const favoriteBtns = $('.c-button.-border-orange.-heart-icon');
    // issue_4141の施策の結果次第で修正
    // 横幅が狭いボタンの場合テキストが入らないため文字をカスタマイズ
    const isShortText = favoriteBtns
      .map(function () {
        return $(this).attr('data-is-square') === 'true';
      })
      .get()
      .some(Boolean);

    const favOn = {
      class: 'c-button -border-orange -heart-icon -sp-text-sm',
      'data-method': 'post',
      innerHTML: isShortText ? 'お気に入り' : 'お気に入り登録',
      href: '/api/v2/applicants/favorites?job_id=',
    };
    const favOff = {
      class: 'c-button -border-orange -heart-icon -sp-text-sm -solid -done',
      'data-method': 'delete',
      innerHTML: isShortText ? 'お気に入り' : 'お気に入り登録済',
      href: '/api/v2/applicants/favorites?job_id=',
    };
    function toggle(favBtn) {
      if (favBtn.className.includes(favOff.class)) {
        // お気に入り登録済みのクラスを削除
        favBtn.classList.remove('-solid', '-done');
        updateFavBtn(favBtn, favOn);
        updateFavoriteBadge(false);
      } else if (favBtn.className.includes(favOn.class)) {
        // お気に入り登録済みのクラスを追加
        favBtn.classList.add('-solid', '-done');
        updateFavBtn(favBtn, favOff);
        updateFavoriteBadge(true);
      }
    }

    function updateFavBtn(favBtn, favState) {
      favBtn.innerHTML = favState.innerHTML;
      favBtn.href = favState.href + favBtn.id;
      favBtn.setAttribute('data-method', favState['data-method']);
    }

    /**
     * お気に入りのバッジの更新処理
     *
     * @param {boolean} isAdd        - いいねの加算か減算かのフラグ
     */
    function updateFavoriteBadge(isAdd) {
      const $badge = $('.js-favorite-badge');
      // 現在のバッジ数を取得（バッジがない場合は 0 とする）
      const currentCount = $badge.length ? Number($badge.text()) : 0;
      // 加算か減算かで新しいカウントを求める
      const newCount = isAdd ? currentCount + 1 : currentCount - 1;

      if (newCount > 0) {
        if ($badge.length) {
          // すでにバッジがあるのでテキストを更新
          $badge.text(newCount);
        } else {
          // バッジが存在しないので、新規作成
          const $newBadge = $('<span>')
            .addClass('favorite-badge js-favorite-badge')
            .text(newCount);
          // .favorite-badge-wrap の中に追加
          $('.favorite-badge-wrap img').first().after($newBadge);
        }
      } else {
        // 0 以下になったのでバッジを削除
        $badge.remove();
      }
    }

    $.each(favoriteBtns, function (i, theBtn) {
      $(this).on('ajax:success', () => {
        $.each(favoriteBtns, (j, btn) => {
          if (btn.id === theBtn.id) {
            toggle(btn);
          }
        });
      });
    });
  },
  false
);
